import { render, staticRenderFns } from "./SalesTile.vue?vue&type=template&id=f6a0f016"
import script from "./SalesTile.vue?vue&type=script&lang=js"
export * from "./SalesTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports